// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Lapr","newExpiryDate":"styles_newExpiryDate__1Ysa8","footer":"styles_footer__2jabw"};